'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _filter2 = require('lodash/filter');

var _filter3 = _interopRequireDefault(_filter2);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _findIndex2 = require('lodash/findIndex');

var _findIndex3 = _interopRequireDefault(_findIndex2);

var _each2 = require('lodash/each');

var _each3 = _interopRequireDefault(_each2);

var _groupBy2 = require('lodash/groupBy');

var _groupBy3 = _interopRequireDefault(_groupBy2);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _ngFileUpload = require('ng-file-upload');

var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

VragenboomController.$inject = ['WebApiService', 'UrlParamService', 'Upload', 'EnvironmentService', '$q', '$timeout', '$window'];


var _ = {
    find: _find3.default,
    findIndex: _findIndex3.default,
    filter: _filter3.default,
    each: _each3.default,
    groupBy: _groupBy3.default
};

var _module = _angular2.default.module('cb.ui-components.schade-melden.cb-vragenboom', ['ngFileUpload']);

_module.directive('cbVragenboom', cbVragenboomDirective);

exports.default = _module;


function cbVragenboomDirective() {
    return {
        scope: true,
        controller: VragenboomController,
        controllerAs: 'vragenboom',
        link: function link(scope, element, attrs, ctrl) {}
    };
}

function VragenboomController(WebApiService, UrlParamService, Upload, EnvironmentService, $q, $timeout, $window) {
    var vm = this;

    var vragen = [];
    var blobdata = [];
    var claimnummer;

    vm.vraag = {};
    vm.vraagArray = []; //Used for navigation
    vm.antwoorden = {};
    vm.errors = {};
    vm.fileUpload = fileUpload;
    vm.removeFile = removeFile;
    vm.fileErrors = [];

    vm.next = next;
    vm.goTo = goTo;
    vm.skipChooseOne = skipChooseOne;
    vm.prev = prev;
    vm.save = save;
    vm.previd;
    vm.getToday = getToday;
    vm.getYesterday = getYesterday;

    vm.chooseOne = chooseOne;
    vm.chooseMultiple = chooseMultiple;
    vm.openAnswer = openAnswer;
    vm.multipleOpenAnswer = multipleOpenAnswer;

    var vragenboom;

    vm.isEnd = false;

    function isLoggedIn() {
        //Only accept logged in customers
        if (typeof cbsiContext === 'undefined' || !cbsiContext.user || !cbsiContext.user.isCustomer) {
            if (!EnvironmentService.isDevelopment()) return false;
        }

        return true;
    }

    function getContractData() {
        var returnData = {};
        // d is base64 of data
        if (UrlParamService.getUrlParam('d')) {
            var base64 = UrlParamService.getUrlParam('d');
            var data = JSON.parse(atob(base64));

            if ((typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object') {
                returnData.polisnummer = data.polisnummer;
                returnData.contractnummer = data.contractnummer;
                returnData.sleutel = data.sleutel;

                // producten is like producten.INB = contractvolgnr
                returnData.producten = data.producten || {};
            }
        } else {
            //Only accept customers who used the correct MijnCB route to acces the page.
            //Contractnummer and polisnummer should be known
            if (UrlParamService.getUrlParam('polisnummer') && UrlParamService.getUrlParam('sleutel')) {
                //if (!EnvironmentService.isDevelopment()) return (window.location = '/mijncentraalbeheer');
                returnData.polisnummer = UrlParamService.getUrlParam('polisnummer');
                returnData.contractnummer = UrlParamService.getUrlParam('contractnummer');
                returnData.sleutel = UrlParamService.getUrlParam('sleutel');
            }
        }

        return returnData;
    }

    function getVragenboom(sleutel, polisnummer, contractnummer) {
        var requestData = {
            InputVragenboom: [{
                Label: 'CBA',
                Kanaal: 'WEB',
                Sleutel: sleutel,
                Polisnummer: polisnummer,
                Contractnummer: contractnummer
            }]
        };

        var deferred = $q.defer();

        vm.loadingNew = true;
        if (sleutel.toLowerCase() === 'woonkiezer') {
            vm.productImage = 'woon';
            WebApiService.get(requestData, 'VerzekeringsKiezer').then(function (response) {
                vm.loadingNew = false;
                return deferred.resolve(response);
            }, function (error) {
                vm.error = true;
                vm.loadingNew = false;
                return deferred.reject();
            });
        } else {
            vm.productImage = 'auto';
            var rq = UrlParamService.getUrlParam('rq') || 'OphalenVragenboom';
            WebApiService.get(requestData, rq).then(function (response) {
                vm.loadingNew = false;
                return deferred.resolve(response);
            }, function (error) {
                vm.error = true;
                vm.loadingNew = false;
                return deferred.reject();
            });
        }

        return deferred.promise;
    }

    var contractData = getContractData();
    var loggedIn = isLoggedIn();

    // If user is not logged in or params ar not correct, redirect to mijn centraal beheer
    if (!EnvironmentService.isDevelopment() && (!loggedIn || !contractData.sleutel || !contractData.polisnummer)) return window.location = '/mijncentraalbeheer';

    function getVraagInputtype(type, control) {
        if (type === 'BUTTON' || type === 'LABEL_001' || type === 'LABEL_004') {
            return 'display';
        } else if (type === 'GESLOTEN_1') {
            return 'choose1';
        } else if (type === 'GESLOTEN_N') {
            return 'chooseN';
        } else if (type === 'OPEN_1') {
            if (control === 'KALENDER_001' || control === 'KALENDER_002') return 'date';
            if (control === 'TEKST_001') return 'text';
            if (control === 'TEKST_002') return 'textarea';
        } else if (type === 'FOTO_004') {
            return 'fileupload';
        } else {
            return 'text';
        }
    }

    function getVraagAntwoorden(vraag) {
        var antwoorden = [];

        _.each(vraag.antwoorden, function (antwoord, key) {
            var a = {};

            a.id = antwoord.id;
            a.next = antwoord.linkt_naar || vraag.linkt_naar;

            a.label = antwoord.titel || antwoord.stappenplan_kop || vraag.groep_titel;
            a.subtitel = antwoord.antwoordregels ? antwoord.antwoordregels[0] : '';
            a.groeptitel = antwoord.groep_titel;

            a.placeholder = antwoord.standaard_waarde_tekst;
            a.variabeleWaarde = antwoord.variabeleWaarde || '';
            a.validaties = antwoord.validatieParameters || [];
            a.verplicht = vraag.verplicht === true ? true : false;
            a.default = antwoord.standaard_waarde === 'True';
            a.bullets = antwoord.antwoord_bullets;

            antwoorden.push(a);
        });

        return antwoorden;
    }

    function detectEnd(vragen) {
        if (_.find(vragen, function (v) {
            return v.vraagtype === 'VRAGENBOOM_EINDE_PROCES';
        })) {
            return true;
        }

        return false;
    }

    function processVragenboom(data) {
        vm.showSaveText = false;
        vm.showSummary = false;
        vm.showSend = false;
        vragen = [];
        blobdata = [];
        vm.vraag = {};
        vm.vraagArray = []; //Used for navigation
        vm.antwoorden = {};
        vm.errors = {};

        window.scrollTo(0, 100);

        if (data && data.ok === true && (data.vragenboom || data.vragenbomen.length > 0)) {
            vragenboom = data.vragenboom || data.vragenbomen[0];
            if (data.claimnummer) claimnummer = data.claimnummer;
        } else {
            return false;
        }

        vm.isEnd = detectEnd(vragenboom.vragen);

        var startvraag;
        var summaryText;

        _.each(vragenboom.vragen, function (v) {
            var vraag = {};

            if (v.startvraag === true && v.control.indexOf('LABEL') !== -1) {
                summaryText = _.filter(vragenboom.vragen, function (vr) {
                    return vr.groep_id === v.groep_id && vr.vraagtype.indexOf('LABEL') !== -1;
                });
                vraag.id = v.id;
                vraag.textblocks = summaryText;
                vraag.type = 'summarytext';
                vraag.next = summaryText[summaryText.length - 1].linkt_naar;
                vraag.nextDisplay = true;
                vraag.endDisplay = false;
                vraag.groepstitel = v.groep_titel || '';

                var nextQuestion = _.find(vragenboom.vragen, function (vr) {
                    return vr.id === vraag.next;
                });

                if (nextQuestion.vraagtype === 'VRAGENBOOM_EINDE_PROCES') {
                    vraag.nextDisplay = false;
                    vraag.endDisplay = true;
                }

                vragen.push(vraag);
            } else {
                vraag.id = v.id;
                vraag.groepstitel = v.groep_titel || '';
                vraag.titel = v.titel || '';
                vraag.display = v.tonen === true ? true : false;
                vraag.hidden = vraag.next = v.linkt_naar;
                vraag.verplicht = v.verplicht === true ? true : false;
                vraag.meervoudig = v.vraagtype === 'OPEN_N' || false;
                vraag.validatieParameters = v.validatieParameters;
                vraag.startvraag = v.startvraag === true ? true : false;
                vraag.eindvraag = v.eindvraag === true ? true : false;
                vraag.product = v.product || [];
                vraag.vraagbullets = v.vraag_bullets || [];
                vraag.vragenboom = v.vragenboom || ''; //for woonkiezer

                if (v.vraagregels) {
                    if (Array.isArray(v.vraagregels)) vraag.vraagregels = v.vraagregels;else {
                        vraag.vraagregels = [];
                        vraag.vraagregels.push(v.vraagregels);
                    }
                }

                if (v.control === 'BUTTON') {
                    vraag.type = 'display';
                } else {
                    vraag.type = getVraagInputtype(v.vraagtype, v.control);
                }

                vraag.antwoorden = getVraagAntwoorden(v);

                if (vraag.type === 'chooseN') {
                    vraag.groepantwoorden = _.groupBy(vraag.antwoorden, 'groeptitel');
                }
            }

            var vraagInSummary = (0, _find3.default)(summaryText, function (v) {
                return v.id === vraag.id;
            });

            if (!vraagInSummary) vragen.push(vraag);

            if (v.startvraag) startvraag = vraag;
        });

        if (vm.isEnd) {
            meting();
        }

        vm.vraag = startvraag;
        vm.vraagArray.push(vm.vraag.id);
    }

    getVragenboom(contractData.sleutel, contractData.polisnummer, contractData.contractnummer).then(function (res) {
        processVragenboom(res);
    });

    function validate(vraag) {
        vm.errors = {};
        var error = false;

        if (vraag.verplicht && !vm.antwoorden[vraag.id]) {
            vm.errors.required = true;
            return false;
        }

        if (vraag.validatieParameters) {
            _.each(vraag.validatieParameters, function (v, k) {
                if (v.type_validatie === 'MIN_MAX' && v.validatie_parameters) {
                    var min = v.validatie_parameters.split(';')[0];
                    var max = v.validatie_parameters.split(';')[1];
                    if (max && vm.antwoorden[vraag.id] && vm.antwoorden[vraag.id].length > max) {
                        vm.errors.maxlength = max;
                        error = true;
                    }

                    if (min && (min > 0 && !vm.antwoorden[vraag.id] || vm.antwoorden[vraag.id] && vm.antwoorden[vraag.id].length < min)) {
                        vm.errors.minlength = min;
                        error = true;
                    }
                }
            });
        }

        var antwoorden = vm.antwoorden[vraag.id];

        _.each(antwoorden, function (antwoord, k) {
            if (antwoord.key) vm.errors[antwoord.key] = {};

            if (vraag.verplicht && (!antwoord || antwoord.length === 0 || antwoord.key && (!antwoord.antwoord || antwoord.antwoord.length === 0))) {
                vm.errors[antwoord.key].required = true;
                error = true;
            }

            var vraagAntwoordValidaties = _.find(vraag.antwoorden, function (v, k) {
                if (!antwoord || !antwoord.key) return false;
                return v.id === antwoord.key;
            });

            if (vraagAntwoordValidaties) {
                var validaties = vraagAntwoordValidaties.validaties;
                if (validaties && vm.errors[antwoord.key] && !vm.errors[antwoord.key].required) {
                    _.each(validaties, function (validatie) {
                        if (validatie.type_validatie === 'REGEX') {
                            var r = new RegExp(validatie.validatie_parameters);
                            if (!r.test(antwoord.antwoord)) {
                                vm.errors[antwoord.key].pattern = true;
                                error = true;
                            }
                        }
                        if (validatie.type_validatie === 'DATUM_KLEINER_GELIJK') {
                            var _date = (0, _moment2.default)(antwoord.antwoord, 'DD-MM-YYYY');
                            if ((0, _moment2.default)().diff(_date) < 0) {
                                vm.errors[antwoord.key].future = true;
                                error = true;
                            }
                        }
                        if (validatie.type_validatie === 'MAX_LENGTE') {
                            if (antwoord.antwoord.length > validatie.validatie_parameters) {
                                vm.errors[antwoord.key].length = true;
                                error = true;
                            }
                        }
                    });
                }
            }
        });

        //if (Object.keys(vm.errors).length > 0) return false;
        return !error;
    }

    function summarize() {
        vm.summary = [];

        _.each(vm.vraagArray, function (va) {
            var summaryQuestion = {};

            var vraag = _.find(vragen, function (v1) {
                return v1.id === va;
            });

            summaryQuestion.titel = vraag.titel;
            summaryQuestion.id = vraag.id;
            summaryQuestion.antwoorden = [];

            if (vraag.display === true && ['date', 'text', 'textarea', 'chooseN', 'choose1', 'fileupload'].indexOf(vraag.type) !== -1) {
                _.each(vm.antwoorden[va], function (a) {
                    if (['date', 'text', 'textarea'].indexOf(vraag.type) !== -1) summaryQuestion.antwoorden.push(a.antwoord);else if (['fileupload'].indexOf(vraag.type) !== -1) summaryQuestion.antwoorden.push(a.openAntwoord);else {
                        var label = _.find(vraag.antwoorden, function (a1) {
                            return a1.id === a;
                        }).label;
                        summaryQuestion.antwoorden.push(label);
                    }
                });

                if (!vm.antwoorden[va] || vm.antwoorden[va].length === 0) summaryQuestion.antwoorden.push('Geen');

                vm.summary.push(summaryQuestion);
            }
        });

        vm.showSummary = true;
    }

    function processWoonkiezer() {
        var noInsurrance = true;
        var product, index;

        _.each(vm.vraag.product, function (p, k) {
            product = p;
            index = k;
            if (noInsurrance === true && contractData.producten[p]) {
                noInsurrance = false;
            }
        });

        if (noInsurrance) {
            vm.noInsurrance = true;

            if (product.toLowerCase() === 'inb') {
                vm.vraag = {};
                vm.GeenInboedel = true;
            } else if (product.toLowerCase() === 'woo') {
                vm.vraag = {};
                vm.GeenOpstal = true;
            } else if (product.toLowerCase() === 'bdd') {
                vm.vraag = {};
                vm.GeenKbh = true;
            }

            return -1;
        } else {
            //avp doen we niet, maar dat zit niet in de html maar in de kiezer. Daarom geen nieuwe data ophalen, maar titel van eindvraag laten zien
            if (product.toLowerCase() === 'avp') {
                return -1;
            }

            return index;
        }
    }

    function next(vraagid) {
        $window.Authentication.resetAutoSignout();

        if (!validate(vm.vraag)) return false;

        vm.previd = vm.vraag.id;

        var vraag = _.find(vragen, function (v) {
            return v.id === vraagid;
        });

        if (vraag.display === false) {
            var defaultAntwoord = _.find(vraag.antwoorden, function (a) {
                return a.default === true;
            });
            if (defaultAntwoord) {
                return chooseOne(vraag.id, defaultAntwoord);
            }
        }

        vm.vraag = vraag;
        vm.vraagArray.push(vm.vraag.id);

        vm.showSummary = false;
        vm.showSend = false;

        if (vm.vraag.eindvraag === true && vm.vraag.vraagtype !== 'VRAGENBOOM_EINDE_PROCES' && contractData.sleutel.toLowerCase() !== 'woonkiezer') {
            summarize();
            vm.showSend = true;
            vm.buttonText = vm.vraag.antwoorden[0].label;
        }

        if (vm.vraag.eindvraag === true && contractData.sleutel.toLowerCase() === 'woonkiezer') {
            vm.showSummary = false;
            vm.showSend = false;
            vm.vraag.type = 'eindtext';

            var insuranceIndex = processWoonkiezer();

            if (insuranceIndex !== -1) {
                vm.loadingNew = true;

                contractData.sleutel = vm.vraag.vragenboom[insuranceIndex];
                contractData.contractnummer = contractData.producten[vm.vraag.product[insuranceIndex]];

                var requestData = {
                    InputVragenboom: [{
                        Label: 'CBA',
                        Kanaal: 'WEB',
                        Sleutel: contractData.sleutel,
                        Polisnummer: contractData.polisnummer,
                        Contractnummer: contractData.contractnummer
                    }]
                };

                WebApiService.get(requestData, 'OphalenVragenboom').then(function (response) {
                    //var data = XmlToJsonService.convert(response);
                    processVragenboom(response);
                    vm.loadingNew = false;
                }, function (error) {
                    vm.error = true;
                    vm.loadingNew = false;
                });
            }
        }

        window.scrollTo(0, 100);
    }

    function goTo(vraagid) {
        var vraag = _.find(vragen, function (v) {
            return v.id === vraagid;
        });

        var indexInVraagArray = _.findIndex(vm.vraagArray, function (v) {
            return v === vraagid;
        });

        vm.vraagArray.length = indexInVraagArray + 1;

        vm.vraag = vraag;
        vm.showSummary = false;
        vm.showSend = false;
    }

    function skipChooseOne() {
        var nextId;
        if (vm.antwoorden[vm.vraag.id]) {
            var x = _.find(vragen, function (v, k) {
                return v.id === vm.vraag.id;
            });
            var nextId = _.find(x.antwoorden, function (v, k) {
                return v.id === vm.antwoorden[vm.vraag.id][0];
            }).next;
        }
        next(nextId);
    }

    function prev(vraagid) {
        var vraag = _.find(vragen, function (v) {
            return v.id === vraagid;
        });
        vm.vraag = vraag;
        vm.vraagArray.splice(-1, 1);
    }

    function chooseOne(vraagid, antwoord) {
        vm.antwoorden[vraagid] = [];
        vm.antwoorden[vraagid].push(antwoord.id);

        next(antwoord.next);
    }

    function chooseMultiple(vraagid, antwoord) {
        vm.antwoorden[vraagid] = vm.antwoorden[vraagid] || [];
        var indexOfAntwoord = vm.antwoorden[vraagid].indexOf(antwoord.id);
        if (indexOfAntwoord !== -1) {
            //Antwoord is geselecteerd. Deselecteren
            vm.antwoorden[vraagid].splice(indexOfAntwoord, 1);
        } else {
            vm.antwoorden[vraagid].push(antwoord.id);
        }
    }

    function openAnswer(vraagid, antwoord, startOfMultipleAnswerLoop, endOfMultipleAnswerLoop) {
        if (!vm.vraag.meervoudig) {
            vm.antwoorden[vraagid] = [];

            var _antwoord = {};
            _antwoord.key = antwoord.id;
            _antwoord.antwoord = antwoord.openAntwoord;

            vm.antwoorden[vraagid].push(_antwoord);
            next(vm.vraag.next || vm.vraag.antwoorden[0].next);
        } else {
            if (startOfMultipleAnswerLoop) vm.antwoorden[vraagid] = [];

            var _antwoord = {};
            _antwoord.key = antwoord.id;
            _antwoord.antwoord = antwoord.openAntwoord;

            vm.antwoorden[vraagid].push(_antwoord);

            if (endOfMultipleAnswerLoop) next(vm.vraag.next || vm.vraag.antwoorden[0].next);
        }
    }

    function multipleOpenAnswer(vraagid, antwoorden) {
        var count = 1;

        _angular2.default.forEach(antwoorden, function (v, k) {
            openAnswer(vraagid, v, count === 1, count === antwoorden.length);
            count += 1;
        });
    }

    function save() {
        var data = {};
        var vraag;
        var vragenboomVragen = vragenboom.vragen;

        data.Vragenboom = vragenboom;
        data.Vragenboom.vragen = [];
        data.Variabele_content_vragenboom = [];

        if (claimnummer) data.Claimnummer = claimnummer;else {
            data.Contractnummer = contractData.contractnummer;
            data.Polisnummer = contractData.polisnummer;
        }

        var startvraag = _.find(vragenboomVragen, function (v) {
            return v.startvraag === true;
        });

        var vraagId = startvraag.id;
        var x = 0;
        var count = 1;
        while (x === 0 && count < 100) {
            count += 1;

            var vraag = _.find(vragenboomVragen, function (v) {
                return v.id === vraagId;
            });

            vraag.antwoorden = _.filter(vraag.antwoorden, function (a) {
                if (vraag.vraagtype === 'GESLOTEN_1') return a.id === vm.antwoorden[vraag.id][0];else if (vraag.vraagtype === 'GESLOTEN_N') {
                    return vm.antwoorden[vraag.id].indexOf(a.id) !== -1;
                } else if (vraag.vraagtype.indexOf('FOTO') !== -1) {
                    var inBlobData = _.find(blobdata, function (b) {
                        return b.AntwoordId === a.id;
                    });
                    if (inBlobData) return true;
                } else {
                    return true;
                }
            });

            data.Vragenboom.vragen.push(vraag);

            if (vraag.eindvraag === true) {
                x = 1;
            } else {
                vraagId = vraag.linkt_naar || vraag.antwoorden[0].linkt_naar;
            }
        }

        _.each(blobdata, function (b, k) {
            var variabeleContent = {};
            variabeleContent.VraagId = b.VraagId;
            variabeleContent.AntwoordId = b.AntwoordId;
            variabeleContent.Attribuutnaam = b.Variabelenaam;
            variabeleContent.Attribuutwaarde = b.VariabeleWaarde;

            if (b.Variabelenaam === 'EXTENSIE') {
                variabeleContent.Attribuutwaarde = variabeleContent.Attribuutwaarde.replace('image/', '');
            }
            data.Variabele_content_vragenboom.push(variabeleContent);
        });

        _.each(data.Vragenboom.vragen, function (v) {
            _.each(v.antwoorden, function (a) {
                if (a.variabeleWaarde && a.variabeleWaarde.length > 0) {
                    var variabele = {
                        VraagId: v.id,
                        AntwoordId: a.id,
                        Attribuutnaam: a.variabeleWaarde.replace('{', '').replace('}', ''),
                        Attribuutwaarde: ''
                    };

                    var atwaarde = _.find(vm.antwoorden[v.id], function (a1, k) {
                        return a1.key === a.id;
                    });

                    if (atwaarde) {
                        variabele.Attribuutwaarde = atwaarde.antwoord;
                        data.Variabele_content_vragenboom.push(variabele);
                    }
                }
            });
        });

        $timeout(function () {
            vm.showSaveText = true;
        }, 5000);
        vm.saving = true;

        WebApiService.get(data, 'IndienenVragenboom').then(function (response) {
            //var data = XmlToJsonService.convert(response);
            vm.showSaveText = false;
            processVragenboom(response);
            vm.saving = false;
        }, function (error) {
            vm.error = true;
            vm.saving = false;
            vm.showSaveText = false;
        });
    }

    var countFiles = 1;

    function fileUpload(id, antwoord, file, index) {
        vm.fileErrors[index] = false;
        if (!/image\/(jpg|png|jpeg)$/i.test(file.type)) {
            vm.fileErrors[index] = true;
            return false;
        }
        vm.antwoorden[id] = vm.antwoorden[id] || [];
        Upload.base64DataUrl(file).then(function (url) {
            antwoord.openAntwoord = file.name;
            var x = {};
            x.VraagId = id;
            x.AntwoordId = antwoord.id;
            x.Variabelenaam = 'EXTENSIE';
            x.VariabeleWaarde = file.type;
            blobdata.push(x);

            x = {};
            x.VraagId = id;
            x.AntwoordId = antwoord.id;
            x.Variabelenaam = 'BLOBDATA';
            x.VariabeleWaarde = url.substring(url.indexOf(',') + 1);
            blobdata.push(x);

            x = {};
            x.VraagId = id;
            x.AntwoordId = antwoord.id;
            x.Variabelenaam = 'BESTANDSNAAM';
            x.VariabeleWaarde = countFiles;
            blobdata.push(x);

            vm.antwoorden[id].push(antwoord);
            vm.files = vm.files || [];
            vm.files[index] = url;

            countFiles += 1;
        });
    }

    function removeFile(id, antwoord, index) {
        var i = _.findIndex(vm.antwoorden[id], function (a, k) {
            return a.id == antwoord.id;
        });
        var ind = _.findIndex(blobdata, function (b, k) {
            return b.VraagId === id && b.AntwoordId === antwoord.id && b.Variabelenaam === 'BLOBDATA';
        });
        blobdata.splice(ind, 1);
        ind = _.findIndex(blobdata, function (b, k) {
            return b.VraagId === id && b.AntwoordId === antwoord.id && b.Variabelenaam === 'EXTENSIE';
        });
        blobdata.splice(ind, 1);
        ind = _.findIndex(blobdata, function (b, k) {
            return b.VraagId === id && b.AntwoordId === antwoord.id && b.Variabelenaam === 'BESTANDSNAAM';
        });
        blobdata.splice(ind, 1);
        vm.antwoorden[id].splice(i, 1);
        vm.files[index] = undefined;
        vm.fileErrors[index] = false;
    }

    function meting() {
        return cb.api.analytics.triggerResult('schadeMeldenSucces');
    }

    function getToday() {
        return (0, _moment2.default)().format('DD-MM-YYYY');
    }

    function getYesterday() {
        return (0, _moment2.default)().add(-1, 'd').format('DD-MM-YYYY');
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/vragenboom/cb-vragenboom-v2.directive.js
// module id = 923
// module chunks = 0